export { default as Confetti } from './Confetti'



// WEBPACK FOOTER //
// ./src/components/confetti/index.js